import { useApi } from "utils"
import { useState } from "react"
import type { SuccessFetch } from "types"
import { BillStatusResponse, TabBillStatusParams } from "../types"

export const useListRegisterBillService = () => {
  const api = useApi()
  const [data, setData] = useState<BillStatusResponse[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = (params: Partial<TabBillStatusParams>) => {
    setLoading(true)

    api.get("/probill/get-bill-service", {
      params: {
        search: params?.search, 
        start_date: params?.start_date, 
        end_date: params?.end_date, 
        approve_status: params?.approve_status ? Number(params?.approve_status) : null,
        bill_status: params?.bill_status,
      }
    })
    .then((res: SuccessFetch<{ payload: BillStatusResponse[] }>) => setData(res.data.payload))
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  return { data, isLoading, refetch }
}